import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface HttpReqOptions {
    headers?: any | HttpHeaders | {
        [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
        [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: any; // need to be checked
    withCredentials?: boolean;

}

@Injectable({
    providedIn: 'root'
})
export class FnHttpService {

    constructor(private http: HttpClient,
    ) { }


    // need to replace with interceptor
    private getUpdatedHeader(headerOpt: HttpReqOptions): HttpReqOptions {
        const csrf = localStorage.getItem('RCTN');

        if (csrf) {
            if (headerOpt) {
                if (headerOpt.headers) {
                    let header = headerOpt.headers;
                    header['csrf'] = csrf;
                    headerOpt.headers = header;
                } else {
                    headerOpt['headers'] = { csrf: csrf };
                }
            } else {
                let header = new HttpHeaders();
                header.set('csrf', csrf + "");
                headerOpt = {
                    headers: header,
                };
            }
        }

        return headerOpt;
    }

    get(path: string, httpReqOption?: HttpReqOptions): Observable<any> {
        return this.http.get(path, httpReqOption).pipe(catchError(this.handleError));
    }


    private simlifiedPath(path: string, actionId?: string): string {
        if (path && actionId && actionId.trim().length > 0) {
            return `${path}/${actionId}`;
        }
        return path;
    }

    post(path: string, body: string | object = {}, actionId: string = "", httpReqOption?: HttpReqOptions): Observable<any> {
        const urlStr = path;
        return this.http.post(
            this.simlifiedPath(path, actionId),
            body,
            this.getUpdatedHeader(httpReqOption)
        ).pipe(catchError(err => this.handleError(err, body)));
    }

    put(path: string, body: object = {}, httpReqOption?: HttpReqOptions): Observable<any> {
        return this.http.put(
            path,
            body,
            httpReqOption
        ).pipe(catchError(err => this.handleError(err, body)));
    }

    delete(path: string, httpReqOption?: HttpReqOptions): Observable<any> {
        return this.http.delete(
            path,
            httpReqOption
        ).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse, body: any) {
        // if (error.status == 500) {
        //     this.errorHelpSvcs.openModal(error, body);
        // }
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
            return throwError('An error occurred: ' + error.error.message);
        } else {
            return of({ status: error.status, message: error.error.message });
        }

    }



    // private handleError {
    //     return (error: any): Observable<any> => {
    //         return of({ status: error.status, message: error.message });
    //     };
    // }
}
